import React from 'react'
import styled from 'styled-components';
import Select from "react-select";

const Dropdown1st2911 = (props) => { 
    const {
    onChange,
    options,
    defaultValue,
    value,
    customStyle,
    // required,
    className,
    width,
    disabled,
    label,
    placeholder,
  } = props.data;
  return (
    <>
      <label>{label}</label>
      <Select1st2911
        styles={customStyle}
        options={options?.map((options, index) => ({
          value: options.value,
          label: options.label,
          id: index,
        }))}
        value={value}
        onChange={onChange}
        className={className}
        defaultValue={defaultValue}
        placeholder={placeholder}
        isDisabled={disabled}
        width={width}
        required
      />
    </>
  )
}
export default Dropdown1st2911;

const Select1st2911 = styled(Select)`
 width: ${(props) => (props.width ? "50%" : "75%")};
  margin-top: 5px;
  padding:5px;
 background-color: var(--white); 
  z-index: 99;
  border: 2px solid var(--orange);
  .css-1jqq78o-placeholder{
     font-weight: var(--regularFont);
    color: var(--black);
    font-family: var(--fontFamily);
    font-size: 16px;
  }
  .css-13cymwt-control{
    border-color: var(--whiteGray);
    box-shadow: 0 0 1px var(--orange);
  }
   @media (max-width: 768px) {
    width: 80%;
  }
 
`